import Fuse from 'fuse.js';
import type { HelpArticleWithCategory } from '../data/helpCenterContent';

export interface SearchOptions {
  threshold?: number; // 0.0 = perfect match, 1.0 = match anything
  keys?: string[];
}

const DEFAULT_OPTIONS: SearchOptions = {
  threshold: 0.3, // Fairly strict matching
  keys: ['title', 'description', 'categoryTitle'], // Fields to search
};

export function createHelpCenterSearch(articles: HelpArticleWithCategory[]) {
  const fuse = new Fuse(articles, {
    ...DEFAULT_OPTIONS,
    includeScore: true,
    minMatchCharLength: 2,
    ignoreLocation: true, // Search anywhere in the string
  });

  return {
    search: (query: string): HelpArticleWithCategory[] => {
      if (!query || query.trim().length < 2) {
        return articles; // Return all articles if query is too short
      }

      const results = fuse.search(query);
      return results.map((result) => result.item);
    },
    
    filterByCategory: (categoryId: string): HelpArticleWithCategory[] => {
      if (!categoryId || categoryId === 'all') {
        return articles;
      }
      return articles.filter((article) => article.categoryId === categoryId);
    },

    searchAndFilter: (query: string, categoryId: string): HelpArticleWithCategory[] => {
      let results = articles;

      // First filter by category if specified
      if (categoryId && categoryId !== 'all') {
        results = results.filter((article) => article.categoryId === categoryId);
      }

      // Then search within filtered results
      if (query && query.trim().length >= 2) {
        const categoryFuse = new Fuse(results, {
          ...DEFAULT_OPTIONS,
          includeScore: true,
          minMatchCharLength: 2,
          ignoreLocation: true,
        });
        const searchResults = categoryFuse.search(query);
        return searchResults.map((result) => result.item);
      }

      return results;
    },
  };
}

